// Source/Slider-Section/Component.ts
import { Pagination, Navigation, Swiper } from "Swiper";
class SliderSection extends HTMLElement {
  swiper;
  connectedCallback() {
    const { container, prev, next } = this;
    this.swiper = new Swiper(container, {
      modules: [Pagination, Navigation],
      direction: "horizontal",
      navigation: {
        prevEl: next,
        nextEl: prev
      },
      slidesPerView: 1,
      spaceBetween: 40,
      breakpoints: {
        640: {
          slidesPerView: 1.4,
          spaceBetween: 30
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  }
  disconnectedCallback() {
    this.swiper?.destroy();
  }
  get container() {
    return this;
  }
  get next() {
    return this.querySelector(".Slider-Control-Prev");
  }
  get prev() {
    return this.querySelector(".Slider-Control-Next");
  }
}

// Source/Slider-Section/mod.ts
customElements.define("slider-section", SliderSection);
